import { Component } from '@verndale/core';
import { loadLazyModules } from '../helpers';

class Modal extends Component {
  setupDefaults() {
    this.dom = {
      closeButton: this.el.querySelector('.modal-close'),
      modalId: this.el.dataset.moduleId
    };

    this.openButtons = document.querySelectorAll(
      `[data-open-modal=${this.dom.modalId}]`
    );
  }

  addListeners() {
    this.dom.closeButton.addEventListener('click', this.close.bind(this));

    if (this.openButtons.length > 0) {
      this.openButtons.forEach(button => {
        button.addEventListener('click', this.open.bind(this));
      });
    }
  }

  open(e) {
    e.preventDefault();
    const { moduleFocus } = e.target.dataset;

    this.el.classList.remove('hide');

    window.requestAnimationFrame(() => {
      this.el.classList.add('js-animate-in');

      setTimeout(() => {
        this.el.removeAttribute('aria-hidden');

        if (moduleFocus) {
          document.querySelector(moduleFocus).focus();
        }
      }, 500);
    });
  
    loadLazyModules(this.el);
  }

  close(e) {
    e.preventDefault();

    if (this.el.classList.contains('js-external-animation')) {
      return;
    }

    this.el.classList.remove('js-animate-in');

    setTimeout(() => {
      this.el.classList.add('hide');
      this.el.setAttribute('aria-hidden', 'true');
    }, 500);
  }
}

export default Modal;
